import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const APP_TOKEN_KEY = "digiponto_app_token";

export const appApi = axios.create({ baseURL: `${BACKEND}/api` });

appApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(APP_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const appTokenStorage = {
  get: () => localStorage.getItem(APP_TOKEN_KEY),
  set: (t) => localStorage.setItem(APP_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(APP_TOKEN_KEY),
};
